import Root from "./root";

const CommonRules = Object.freeze({
    Root: new Root()
});

export default CommonRules;
